























import { Component, Vue } from "vue-property-decorator";
import Dropdown from "./Dropdown.vue";
import Quota from "./Quota.vue";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({
  components: {
    dropdown: Dropdown,
    quota: Quota,
  },
})
export default class Navbar extends Vue {
  @Auth.Getter("isAuthenticated") isAuthenticated: boolean;
}
